import { isEnrolledStatus } from "@/types/employeeState";
import React from "react";
import { Beneficiary } from "../../../../types/beneficiaries";
import AddBeneficiaryForm from "../../../Common/Forms/AddBeneficiaryForm";

interface BeneficiaryListProps {
  beneficiaries: Beneficiary[];
  enrolledStatus: string;
  isUserEnrolled?: boolean;
  onBeneficiaryChange: (
    index: number,
    field: keyof Beneficiary,
    value: string,
  ) => void;
  onBeneficiaryDelete: (beneficiary: Beneficiary) => Promise<void>;
}

const BeneficiaryList: React.FC<BeneficiaryListProps> = ({
  beneficiaries,
  enrolledStatus,
  isUserEnrolled,
  onBeneficiaryChange,
  onBeneficiaryDelete,
}) => {
  const shouldShowDeleteIcon = (beneficiary: Beneficiary) => {
    return (
      !isEnrolledStatus(enrolledStatus) &&
      (beneficiaries.length > 1 ||
        !!(
          beneficiary.firstName ||
          beneficiary.lastName ||
          beneficiary.relationship ||
          beneficiary.dateOfBirth
        ))
    );
  };

  return (
    <div
      className={`z-10 ${
        !isUserEnrolled &&
        "text-[18px] shadow-introBox  font-outfit bg-white w-full rounded-t-[16px]"
      }`}
    >
      {beneficiaries?.map((beneficiary, index) => (
        <div key={beneficiary.id || beneficiary.tempId}>
          <div
            className={` ${
              isUserEnrolled ? "pb-[24px]" : "px-[16px] py-[32px] md:p-[32px]"
            }`}
          >
            <AddBeneficiaryForm
              index={index}
              values={beneficiary}
              onChange={(field, value) =>
                onBeneficiaryChange(index, field, value)
              }
              showDeleteIcon={shouldShowDeleteIcon(beneficiary)}
              onDelete={() => onBeneficiaryDelete(beneficiary)}
              isUserEnrolled={isUserEnrolled}
            />
          </div>

          {beneficiaries.length > 1 && index !== beneficiaries.length - 1 && (
            <hr />
          )}
        </div>
      ))}
    </div>
  );
};

export default BeneficiaryList;
